import balanceText from 'balance-text'

const watching = []
let handlersInitialized = false

function debounce(func, threshold, execAsap, ...args) {
  let timeout

  return function () {
    const obj = this

    function delayed() {
      if (!execAsap) {
        func.apply(obj, args)
      }
      timeout = null
    }

    if (timeout) {
      clearTimeout(timeout)
    } else if (execAsap) {
      func.apply(obj, args)
    }
    timeout = setTimeout(delayed, threshold || 100)
  }
}

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn()
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn)
  } else {
    document.attachEvent('onreadystatechange', () => {
      if (document.readyState !== 'loading') {
        fn()
      }
    })
  }
}

function updateWatched() {
  watching.forEach((element) => {
    const padding = window.getComputedStyle(element).padding
    const oldDisplay = element.style.display
    const oldMargin = element.style.margin
    const oldPadding = element.style.padding
    /*
    Display span as block when balancing text.
    Padding is moved to margin so that width is calculated correctly
    */
    element.style.display = 'block'
    element.style.margin = padding
    element.style.padding = 0
    balanceText(element)
    element.style.display = oldDisplay
    element.style.margin = oldMargin
    element.style.padding = oldPadding
  })
}

function initializeHandlers() {
  if (handlersInitialized) {
    return
  }

  // Apply on DOM ready
  ready(updateWatched)

  // Reapply on full load
  window.addEventListener('load', updateWatched)

  // Reapply on resize
  window.addEventListener('resize', debounce(updateWatched))

  handlersInitialized = true
}

export function balanceAndWatch(elements) {
  watching.push(...elements)
  initializeHandlers()
  updateWatched()
}
